import useTranslation from 'next-translate/useTranslation';
import { useRef, useState, useEffect, useContext } from 'react';
import { combineClassNames, Tooltip } from '@arkestro/arkestro-design-system';
import PropTypes from 'prop-types';

import { UserContext } from '@components/providers/UserProvider/UserProvider';
import { capitalize } from '@utils/strings';

import style from './UserInfoDisplay.module.scss';

export const UserInfoDisplay = ({ rightAlign = false, isInDropdown = false }) => {
  const { t } = useTranslation('common');
  const user = useContext(UserContext);

  let userType = user.category;

  if (userType === 'vendor') userType = t('tooltip.user_info.vendor');
  if (userType === 'buyer') userType = t('tooltip.user_info.buyer');

  const displayUserType = capitalize(userType);
  const displayName = user.first_name ? user.name : user.email;
  const displayCompany = `${displayUserType} ${t('tooltip.user_info.of')} ${user.company_name}`;
  const nameRef = useRef(null);
  const companyRef = useRef(null);
  const [titleName, setTitleName] = useState();
  const [titleCompany, setTitleCompany] = useState();
  const className = combineClassNames([
    'user-info-display',
    style.userDisplay,
    !rightAlign ? style.flexStart : style.flexEnd
  ]);

  useEffect(() => {
    if (nameRef?.current?.offsetWidth < nameRef?.current?.scrollWidth) {
      setTitleName(displayName);
    }
  }, [nameRef?.current, displayName]);
  useEffect(() => {
    if (companyRef?.current?.offsetWidth < companyRef?.current?.scrollWidth) {
      setTitleCompany(displayCompany);
    }
  }, [companyRef?.current, displayCompany]);

  return (
    <div className={isInDropdown ? style.userDisplayInMenu : ''}>
      <div className={className}>
        <div ref={nameRef} className={style.displayName} data-testid='user-name'>
          <Tooltip placement='bottomLeft' title={titleName}>
            {displayName}
          </Tooltip>
        </div>
        <div ref={companyRef} className={style.displayCompany} data-testid='user-company'>
          <Tooltip placement='bottomLeft' title={titleCompany}>
            {displayCompany}
          </Tooltip>
        </div>
      </div>
    </div>
  );
};

UserInfoDisplay.propTypes = {
  isInDropdown: PropTypes.bool,
  rightAlign: PropTypes.bool
};
